import { API_FETCH } from "../../Utils/Index";

export const GetContactForOpportunites = (opportunityId: any) => {
	const myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");

	const requestOptions: any = {
		method: "POST",
		headers: myHeaders,
		body: JSON.stringify({
			opportunityId,
			pod_user_id: Number(localStorage.getItem("podUserId")),
		}),
		redirect: "follow",
	};
	return new Promise((resolve, reject) => {
		fetch(API_FETCH(`/get_contacts_for_opportunity`), requestOptions)
			.then((response) => response.json())
			.then((result) => resolve(result))
			.catch((error) => {
				console.warn("error while getting Opportunites =>", error);
				reject(error);
			});
	});
};
